import React from "react";
import "./Refund.css";

const Refund = () => {
  return (
    <div className="refund-page">
      <h1>Refund and Cancellation Policy</h1>
      <p><strong></strong></p>

      <section>
        <h2>Our Commitment</h2>
        <p>
          At Vero Disruptors, we strive to provide exceptional IT and software services to our clients. 
          This Refund and Cancellation Policy outlines the conditions under which refunds or cancellations 
          may be applicable to our services. Please read this policy carefully before engaging with us.
        </p>
      </section>

      <section>
        <h2>Refund Eligibility</h2>
        <p>
          Refunds are applicable only under the following circumstances:
        </p>
        <ul>
          <li>
            <strong>Service Not Delivered:</strong> If Vero Disruptors fails to deliver the agreed-upon 
            service within the specified timeline due to our fault, you may be eligible for a full or 
            partial refund, depending on the extent of non-delivery.
          </li>
          <li>
            <strong>Duplicate Payment:</strong> If you have been charged more than once for the same 
            service due to a technical error, we will refund the excess amount.
          </li>
        </ul>
        <p>
          <strong>Note:</strong> Refunds are not applicable for dissatisfaction with the service outcome 
          if the service has been delivered as per the agreed terms, or if the client changes their mind 
          after the service has been initiated.
        </p>
      </section>

      <section>
        <h2>Cancellation Policy</h2>
        <p>
          Cancellations are permitted under these conditions:
        </p>
        <ul>
          <li>
            <strong>Before Service Initiation:</strong> If you cancel your order before we begin 
            providing the service, you may be eligible for a full refund, minus any applicable 
            processing fees (if any).
          </li>
          <li>
            <strong>After Service Initiation:</strong> Cancellations after the service has started 
            are not eligible for refunds unless explicitly agreed upon in the service contract.
          </li>
        </ul>
      </section>

      <section>
        <h2>How to Request a Refund or Cancellation</h2>
        <p>
          To request a refund or cancellation, please contact us at:
        </p>
        <ul>
          <li><strong>Email:</strong> venkatmor@verodisruptors.com</li>
          <li><strong>Phone:</strong> +91 9032584791</li>
          <li><strong>Address:</strong> H.No: 3-77, Thimmanapalem(V),
Korisapadu (MD), Bapatla (DT),
Andhra Pradesh, India - 523212
</li>
        </ul>
        <p>
          Please include your order details and a brief explanation of your request. We will review your 
          request and respond within 7-10 business days.
        </p>
      </section>

      <section>
        <h2>Non-Refundable Services</h2>
        <p>
          Certain services, such as custom software development or consulting hours already rendered, 
          are non-refundable once completed or partially delivered, as they are tailored to your specific 
          requirements.
        </p>
      </section>

      <section>
        <h2>Changes to This Policy</h2>
        <p>
          Vero Disruptors reserves the right to update or modify this Refund and Cancellation Policy at 
          any time. Any changes will be reflected on this page with an updated "Last Updated" date.
        </p>
      </section>
    </div>
  );
};

export default Refund;